import { useFeatures, type WorkspaceFeatures } from "@expert/features";
import { WidgetContainer as DecoupledWidgetContainer } from "@expert/sales-tools";
import { ErrorBoundary } from "react-error-boundary";

import { useLogger } from "@/sdk/logging";

import { WidgetContainer } from "./components/WidgetContainer";

export function WidgetContainerWrapper() {
    const { features } = useFeatures<WorkspaceFeatures>();
    const logger = useLogger({ module: "WidgetContainerWrapper" });

    if (features.isUsingDecoupledSalesComponents) {
        return (
            <ErrorBoundary
                fallback={<WidgetContainer />}
                onError={(error) => {
                    logger.error({ error }, "Decoupled WidgetContainer crashed, falling back to original");
                }}
            >
                <DecoupledWidgetContainer />
            </ErrorBoundary>
        );
    }

    return <WidgetContainer />;
}
